import { SnapshotIn, types } from 'mobx-state-tree';

export const SearchResult = types.model({
  next: types.maybeNull(types.string),
  total: types.maybeNull(types.number),
  size: types.maybeNull(types.number),
  limit: types.maybeNull(types.number),
});
export interface SearchResult extends SnapshotIn<typeof SearchResult> {}
